import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ar from './locales/ar.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    lng: 'ar',                    // 🇸🇦 الافتراضي عربي
    fallbackLng: 'ar',
    supportedLngs: ['ar', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      // 🚫 لا نستخدم navigator/browser language — العربي افتراضي دائماً للزائر الجديد
      //    إذا اختار المستخدم الإنجليزي يدوياً، يُحفظ في localStorage ويلتزم به
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

// ضبط html dir/lang عند التغيير
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// عند الإقلاع
document.documentElement.lang = i18n.language || 'ar';
document.documentElement.dir = (i18n.language || 'ar') === 'ar' ? 'rtl' : 'ltr';

export default i18n;
